export const defaultSelectedContact = () => {
    let city_id = null;
    let department_id = null;
    let subscriber_id = null;

    const user = localStorage.getItem('user');
    const selected_branch_office = +localStorage.getItem('selected_branchoffice');

    if (selected_branch_office) {
        let branch_offices = localStorage.getItem('branchoffices');

        if (branch_offices) {
            const branch_office = JSON.parse(branch_offices).find(b => b.id === selected_branch_office);

            if (branch_office) {
                city_id = branch_office.city_id;

                if (branch_office.city) {
                    department_id = branch_office.city.department_id;
                }
            }
        }
    }

    if (user) {
        subscriber_id = JSON.parse(user).subscriber_id;
    }

    return {
        id: null,
        subscriber_id: subscriber_id,
        identification_type: '',
        identification: '',
        check_digit: '',
        name: '',
        surname: '',
        address: '',
        main_telephone: '',
        is_customer: 1,
        email: '',
        email_electronic_invoice: '',
        birthdate: '',
        price_list_id: null,
        full_name_with_identification: '',
        fiscal_responsibility_id: null,
        city_id: city_id,
        customer: {
            required_purchase_order: 0,
            invoice_without_quota_control: true
        },
        city: {
            department_id: department_id
        },
        warehouses: [
            {
                seller_id: null,
                city: {}
            }
        ]
    };
};

export const cities = () => {
    const selected_branch_office = +localStorage.getItem('selected_branchoffice');

    if (selected_branch_office) {
        let branch_offices = localStorage.getItem('branchoffices');

        if (branch_offices) {
            const branch_office = JSON.parse(branch_offices).find(b => b.id === selected_branch_office);

            if (branch_office && branch_office.city) {
                return [branch_office.city];
            }
        }
    }

    return [];
};

export const departments = () => {
    const selected_branch_office = +localStorage.getItem('selected_branchoffice');

    if (selected_branch_office) {
        let branch_offices = localStorage.getItem('branchoffices');

        if (branch_offices) {
            const branch_office = JSON.parse(branch_offices).find(b => b.id === selected_branch_office);

            if (branch_office && branch_office.city && branch_office.city.department) {
                return [branch_office.city.department];
            }
        }
    }

    return [];
};


export default {
    params_contacts: {
        only_active: true,
        only_active_api_search: true,
        filter: '',
        type: 'is_customer',
        is_customer: true,
        paginate: false,
        contact_id: null,
        contact_warehouse_id: null,
        with_contact_warehouses: 0
    },
    client: defaultSelectedContact(),
    complete: false,
    show_component: false,
    identificationTypes: [], //Tipos de identificación
    priceLists: [], // Listas de precios de clientes,
    contacts: [],
    tax_responsibilities: [],
    modal_question: {show: false},
    departments: departments(),
    cities: cities(),
    sellers: [],
    selected_model: null,
    subscriber: {},
    taxes: [],
    branch_office: {},
    contact_warehouse: null,
    contactVehicles: []
};



// WEBPACK FOOTER //
// ./src/modules/clients-component/state.js